<template>
  <article class="insurace-variant-card" :class="{'insurace-variant-card--selected': isSelected}">
    <h3 class="insurace-variant-card__title" v-html="title" />

    <p class="insurace-variant-card__subtitle">
      {{ subtitle }}
    </p>

    <div class="insurace-variant-card__price">
      <p v-if="oldPrice.length" class="insurace-variant-card__price-old">
        {{ oldPrice }} ₽
      </p>
      <span v-if="oldPrice.length">&nbsp;</span>
      <p class="insurace-variant-card__price-new">
        <span class="insurace-variant-card__price-new">
          {{ price }} ₽
        </span>
      </p>
    </div>

    <div class="insurace-variant-card__body">
      <ul class="insurace-variant-card__list">
        <li
          class="insurace-variant-card__list-item"
          v-for="(item, idx) in listItems"
          :key="idx"
        >
          <!--TODO: пока решили скрыть-->
          <ElTooltip
            v-if="false"
            placement="top-start"
            :raw-content="true"
            raw-content=true
            :content="item.tooltip"
          >
            <SvgIcon
              class="insurace-variant-card__list-item-icon"
              name="question-in-circle"
              size="small"
            />
          </ElTooltip>
          <div class="insurace-variant-card__list-item-content">
            <p class="insurace-variant-card__list-item-text">
              {{ item.text }}
            </p>
            <p class="insurace-variant-card__list-item-price">
              <strong class="insurace-variant-card__price-new--strong">
                {{ item.price }} ₽
              </strong>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <BaseButton
      class="insurace-variant-card__submit-button"
      :text="submitText"
      theme="primary-invert"
      long
      @click.native="$emit('tariff-chosen', tariff, !isSelected)"
    />
  </article>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'InsuranceVariantCard',
  components: {
    BaseButton,
    SvgIcon
  },
  props: {
    tariff: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    oldPrice: {
      type: String,
      required: false,
      default: ''
    },
    price: {
      type: String,
      required: true,
    },
    submitText: {
      type: String,
      required: false,
      default: 'Выбрать'
    },
    listItems: {
      type: Array,
      required: true,
      validator: function (list) {
        return list.every(item => !!item.text.length && !!item.price.length)
      }
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.insurace-variant-card {
  $border-radius-desktop: $border-radius-default;
  $padding-desktop: $gap-medium;

  position: relative;

  padding: rem($padding-desktop);

  border: 1px solid $primary-weekened;
  border-radius: rem($border-radius-desktop);

  transition: border-color $transition-duration $transition-function;

  &:hover {
    border-color: $primary;
  }

  &--selected {
    border-color: $bondi-blue;
    background-color: rgba($swans-down, 0.3);

    &:hover {
      border-color: $bondi-blue;
    }
  }

  &--selected & {
    &__submit-button {
      color: $white;
      background-color: $bondi-blue;

      &:focus {
        color: $white;
        background-color: $bondi-blue;
      }

      &:hover {
        color: $white;
        background-color: $bondi-blue;
      }
    }
  }

  &__title {
    $safe-margin: 10px;
    @include text-average($font-weight-bold, $line-height-normal);

    flex-grow: 1;

    margin: 0 0 rem(8px);

    @media #{$screen-big} {
      flex-grow: 0;

      width: rem(200px);
    }

    @media #{$screen-small} {
      font-size: rem($font-size-normal);

      flex-grow: 1;

      width: auto;
    }

    &-icon {
      $width-desktop: 30px;
      $height-desktop: 28px;

      width: rem($width-desktop);
      height: rem($height-desktop);
      margin-right: rem($gap-normal);

      &-pic {
        @include object-cover-full;
      }
    }
  }

  &__subtitle {
    @include text-small;

    margin: 0;

    @media #{$screen-big} {
      margin: 0 0 rem($gap-mini);
    }

    @media #{$screen-medium} {
      font-size: rem($font-size-mini);
    }
  }

  &__price {
    position: absolute;
    top: rem(24);
    right: rem(24);

    @media #{$screen-medium} {
      position: static;
    }

    &-old {
      @include text-average($font-weight-regular, $line-height-normal);

      display: inline-block;

      color: $color-text-muted;

      text-decoration: line-through;

      @media #{$screen-medium} {
        font-size: rem($font-size-small);
      }
    }

    &-new {
      @include text-average($font-weight-regular, $line-height-normal);

      display: inline-block;

      color: $primary-weekened;

      @media #{$screen-medium} {
        font-size: rem($font-size-small);
      }

      &--strong {
        @include text-increased($font-weight-bold);

        @media #{$screen-medium} {
          font-size: rem($font-size-medium);
        }
      }

    }
  }

  &__body {
    $vertical-padding-desktop: $gap-medium;

    flex-grow: 1;

    padding: rem(17px) 0 0;

    @media #{$screen-big} {
      padding: rem(8px) 0 rem(26px);
    }
  }

  &__list {
    &-item {
      @include resetting-vertical-indentation-of-first;

      display: flex;

      margin-top: rem($gap-normal);

      &-content {
        display: flex;
        gap: rem(8);
        align-items: center;
      }

      &-icon {
        margin-right: rem($gap-tiny);

        color: $primary;

        cursor: pointer;
      }

      &-text {
        @include text-small;

        color: $color-text-secondary;

        @media #{$screen-medium} {
          font-size: rem($font-size-mini);
        }
      }

      &-price {
        @include text-normal($font-weight-semibold, $line-height-normal);

        color: $primary;

        @media #{$screen-medium} {
          font-size: rem($font-size-small);
        }
      }
    }
  }

  &__submit-button {
    $height-desktop: 49px;

    position: absolute;
    bottom: rem(24);
    right: rem(24);

    width: auto;

    @media #{$screen-medium} {
      position: static;

      width: 100%;
      height: rem($height-desktop);
    }

    &:focus {
      color: $bondi-blue;
      background-color: transparent;
    }

    &:hover {
      color: $bondi-blue;
      background-color: transparent;
    }
  }
}
</style>
